module.exports = __webpack_public_path__ + "static/promotion-cover--008-e205156b214ef189b086353ce350144e.jpg";